<form [formGroup]="form">
  <portal-modal-header
    [title]="'meeting.' + (meeting != null ? 'edit' : 'create') | translate"
    (onClose)="dismiss()"
  ></portal-modal-header>

  <portal-modal-body>
    <portal-errors [errors]="error"></portal-errors>

    <!-- Name -->
    <div class="form-group">
      <label class="form-label" for="name">{{ 'meeting.name' | translate }}</label>

      <input
        class="form-control"
        id="name"
        autocomplete="off"
        formControlName="name"
        portalInputValidityState
        type="text"
      />

      <portal-form-validation-errors controlName="name"></portal-form-validation-errors>
    </div>

    <!-- Scheduled meeting -->
    <div class="form-group">
      <label class="form-label" for="scheduledMeeting">{{ 'meeting.scheduled' | translate }}</label>

      <div>
        <portal-switch-toggle
          id="scheduledMeeting"
          formControlName="scheduledMeeting"
          size="small"
        ></portal-switch-toggle>
      </div>

      <portal-form-validation-errors controlName="scheduledMeeting"></portal-form-validation-errors>
    </div>

    <div class="update-meeting__date">
      @if (form.value.scheduledMeeting) {
        <!-- Start -->
        <div class="form-group">
          <label class="form-label" for="start">{{ 'meeting.start' | translate }}</label>
          <portal-date-picker id="start" [withTime]="true" formControlName="start"></portal-date-picker>
          <portal-form-validation-errors controlName="start"></portal-form-validation-errors>
        </div>
        <!-- Duration -->
        <div class="form-group">
          <label class="form-label" for="duration">{{ 'meeting.duration' | translate }}</label>
          <input
            class="form-control"
            id="duration"
            autocomplete="off"
            formControlName="duration"
            placeholder="Dauer"
            portalInputValidityState
            type="number"
          />
          <portal-form-validation-errors controlName="duration"></portal-form-validation-errors>
        </div>
      }
    </div>

    <!-- Members -->
    <portal-update-meeting-members
      class="d-block form-group"
      [userMap]="userMap"
      formControlName="members"
    ></portal-update-meeting-members>

    <!-- SiteId -->
    @if (sites.length > 1) {
      <div class="form-group">
        <label class="form-label" for="siteId">{{ 'site' | translate }}</label>
        <ng-select
          id="siteId"
          [clearable]="false"
          [items]="sites"
          bindLabel="name"
          bindValue="id"
          formControlName="siteId"
          portalInputValidityState
        ></ng-select>
        <portal-form-validation-errors controlName="siteId"></portal-form-validation-errors>
      </div>
    }

    <!-- Unique name -->
    <div class="form-group">
      <label class="form-label" for="uniqueName">{{ 'meeting.uniqueName' | translate }}</label>

      <input
        class="form-control"
        id="uniqueName"
        autocomplete="off"
        formControlName="uniqueName"
        portalInputValidityState
        type="text"
      />

      <portal-form-validation-errors controlName="uniqueName"></portal-form-validation-errors>
    </div>

    <!-- Passphrase -->
    <div class="form-group">
      <label class="form-label" for="userPassphrase">{{ 'meeting.userPassphrase' | translate }}</label>

      <input
        class="form-control"
        id="userPassPhrase"
        autocomplete="off"
        formControlName="userPassphrase"
        portalInputValidityState
        type="text"
      />

      <portal-form-validation-errors controlName="userPassphrase"> </portal-form-validation-errors>
    </div>

    <!-- No admin timeout -->
    <div class="form-group">
      <label class="form-label" for="noAdminTimeout">{{
        'meeting.noAdminTimeout.minutes' | translate
      }}</label>

      <!-- Question mark with details -->
      <i
        class="far fa-question-circle ms-1 tooltip-help"
        [html]="true"
        [interactive]="true"
        [portalTippy]="'meeting.timeout.in.minutes.info' | translate"
        appendTo="body"
        header-extras
      ></i>
      <!-- Question mark with details -->

      <input
        class="form-control"
        id="noAdminTimeout"
        autocomplete="off"
        formControlName="noAdminTimeout"
        max="100"
        min="0"
        portalInputValidityState
        type="number"
      />

      <portal-form-validation-errors controlName="noAdminTimeout"></portal-form-validation-errors>
    </div>

    <!-- Dial in -->
    <div class="form-check">
      <input class="form-check-input" id="dialIn" formControlName="dialIn" name="dialIn" type="checkbox" />

      <label class="form-check-label" for="dialIn">
        {{ 'meeting.dialIn' | portalTranslate }}
      </label>
    </div>

    <!-- Video mode -->
    <div class="form-check mb-3">
      <input
        class="form-check-input"
        id="videoMode"
        formControlName="videoMode"
        name="videoMode"
        type="checkbox"
      />

      <label class="form-check-label" for="videoMode">
        {{ 'meeting.videoMode' | portalTranslate }}
      </label>
    </div>
  </portal-modal-body>

  <portal-modal-footer
    [invalid]="form.invalid"
    [saving]="saving"
    (onCancel)="dismiss()"
    (onSave)="save()"
  ></portal-modal-footer>
</form>
